import { queryOptions } from '@tanstack/react-query';
import branditRails from '../../../../api/brandit_rails';
export const featureFlagsKey = ['commandPaletteFlags'];
export const featureFlagsQueryOptions = (enabled = true) => queryOptions({
    queryKey: featureFlagsKey,
    enabled,
    queryFn: async () => {
        const { data } = await branditRails.get('/admin/organization/feature_flags');
        return data;
    }
});
export const toggleFeatureFlag = async (flagId) => {
    const { data } = await branditRails.patch(`/admin/organization/feature_flags/${flagId}/toggle`);
    return data;
};
